/** View-model derivation for the Process Library screen. */
import { accentVars, iconPath, type ProcessRow } from '@wand/shared';
import type { GlanceTile } from '../data/processes.js';

/** Icon + accent tokens for a process row — derived from the row itself, so it
 *  works for any org's processes (not just the canonical/shared ones). */
export const procMeta = (p: ProcessRow) => ({ icon: iconPath(p.icon), ...accentVars(p.accent) });

/** Header stats derived from the live process list (works on every org, incl. empty). */
export function processGlance(rows: ProcessRow[]): GlanceTile[] {
  const deployed = rows.filter((p) => p.status === 'Deployed').length;
  const draft = rows.filter((p) => p.status === 'Draft').length;
  const review = rows.filter((p) => p.status === 'Needs review').length;
  const cases = rows.reduce((n, p) => n + (p.active || 0), 0);
  return [
    { label: 'Processes live', value: String(deployed), sub: `${draft} in draft` },
    { label: 'Cases running', value: cases.toLocaleString('en-US'), sub: 'active' },
    {
      label: 'Needs attention',
      value: String(review),
      sub: 'to review',
      valueColor: review > 0 ? 'var(--red)' : 'var(--ink)',
    },
    // Not derivable from a process row — illustrative when populated, blank when empty.
    { label: 'Handled by agent', value: rows.length ? '82%' : '—', sub: 'no human needed' },
  ];
}
